import { set, keyBy } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import getPackageAvailabilityUniqId from '../../../../helpers/getPackageAvailabilityUniqId';
import {
  fetchInventoryPackageAvailability,
  fetchInventoryPackagesAvailability,
  deleteInventoryPackageAvailability
} from '../../sagas/routines';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import deleteAvailabilityHandler from '../../../../helpers/deleteAvailabilityHandler';
import { paginationSuccessHandler } from '../../../../helpers/reducerPaginationHandler';
import { clearInventoryPackagesAvailability } from '../../actions';
import {
  inventoryPackagesAvailabilityOnChangePage,
  inventoryPackagesAvailabilityOnChangeOrder
} from '../../actions/package';

const initialState = {
  byUniqId: {},
  byItemId: {},
  fetched: false,
  fetching: false,
  fetchingError: null,
  fetchingByItem: false,
  fetchingByItemError: false,
  deleting: false,
  deleted: false,
  byUniqPagination: paginationState(),
  order: 'lastUpdated:desc'
};

export const fetchPackageAvailabilityHandler = routine => ({
  [routine.TRIGGER]: set('fetchingByItem', true),
  [routine.SUCCESS]: (state, { payload: { id, response } }) => ({
    ...state,
    byItemId: set(id, response.items, state.byItemId)
  }),
  [routine.FAILURE]: (state, { error }) =>
    set('fetchingByItemError', error, state),
  [routine.FULFILL]: set('fetchingByItem', false)
});

export const fetchPackagesAvailabilityHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) => ({
    ...state,
    byUniqId: {
      ...state.byUniqId,
      ...keyBy(getPackageAvailabilityUniqId, response.items)
    },
    byUniqPagination: paginationSuccessHandler(
      state.byUniqPagination,
      response,
      getPackageAvailabilityUniqId
    )
  }),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export const clearInventoryPackagesAvailabilityHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    byUniqId: {},
    byItemId: {},
    fetched: false,
    byUniqPagination: resetPaginationState(state.byUniqPagination)
  })
});

const updateInventoryPackagesAvailabilityCurrentPageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('byUniqPagination.currentPage', page, state)
});

const updateInventoryPackagessAvailabilityOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...fetchPackageAvailabilityHandler(fetchInventoryPackageAvailability),
  ...fetchPackagesAvailabilityHandler(fetchInventoryPackagesAvailability),
  ...deleteAvailabilityHandler(deleteInventoryPackageAvailability),
  ...clearInventoryPackagesAvailabilityHandler(
    clearInventoryPackagesAvailability
  ),
  ...updateInventoryPackagesAvailabilityCurrentPageHandler(
    inventoryPackagesAvailabilityOnChangePage
  ),
  ...updateInventoryPackagessAvailabilityOnChangeOrderHandler(
    inventoryPackagesAvailabilityOnChangeOrder
  )
});
